import { fromDatePickerFormat, toDatePickerFormat } from '../../../../../utils/dateHelpers';
import RadioButton from '../../../../../components/RadioButton';
import DatePicker from '../../../../../components/DatePicker';
import styles from './style.module.scss';

interface Props {
    from: string;
    to: string;
    /** Label of the toggle that marks the range as still running. */
    ongoingLabel: string;
    isOngoing: boolean;
    setFrom: (date: string) => void;
    setTo: (date: string) => void;
    setIsOngoing: (ongoing: boolean) => void;
};

/** From / to dates with a toggle that hides the end date while it is open ended. */
function DateRangeFields(props: Props) {
    const { from, to, isOngoing, ongoingLabel, setFrom, setTo, setIsOngoing } = props;

    return (
        <div className={styles.date}>
            <RadioButton
                text={ongoingLabel}
                checked={isOngoing}
                setChecked={setIsOngoing}
            />
            <div className={styles.date_fromTo}>
                <DatePicker
                    label='From'
                    placeholder='MM-DD-YYYY'
                    selectedDate={toDatePickerFormat(from)}
                    setSelectedDate={val => setFrom(fromDatePickerFormat(val))}
                />
                {!isOngoing && <DatePicker
                    label='To'
                    placeholder='MM-DD-YYYY'
                    selectedDate={toDatePickerFormat(to)}
                    setSelectedDate={val => setTo(fromDatePickerFormat(val))}
                />}
            </div>
        </div>
    );
};

export default DateRangeFields;
